import { useTranslation } from 'react-i18next'

import Text from '../../../../../Text'
import { RentalPortalKeyFactsWidgetItem } from '../../../../RentalPortalKeyFactsWidgetItem'
import { ApplicantCreditCheckActions } from '../ApplicantCreditCheckActions'
import {
  getApplicantCreditCheckDismissedTexts,
  getApplicantCreditCheckResults,
  getApplicantCreditCheckRows,
  getApplicantCreditCheckSuggestions,
  getIsApplicantCreditCheckAwaiting,
  getIsApplicantCreditCheckInconclusive,
} from '../ApplicantCreditCheckBlock.utils'
import { ApplicantCreditCheckResult } from '../ApplicantCreditCheckResult'
import { ApplicantCreditCheckSuggestions } from '../ApplicantCreditCheckSuggestions'
import { ApplicantCreditCheckSupplementary } from '../ApplicantCreditCheckSupplementary'

import * as styles from './ApplicantCreditCheckContent.module.css'

function ApplicantCreditCheckContent({ applicantData, isPreview }) {
  const { t } = useTranslation()

  const creditCheck = applicantData.credit_check

  const canViewSensitive = applicantData.permissions?.can_view_sensitive

  const dismissedTexts = getApplicantCreditCheckDismissedTexts({
    creditCheck,
    t,
  })

  const supplementary = getApplicantCreditCheckResults(creditCheck)

  const suggestions = getApplicantCreditCheckSuggestions(creditCheck)

  return (
    <>
      {suggestions.length > 0 ? (
        <ApplicantCreditCheckSuggestions
          applicantData={applicantData}
          isPreview={isPreview}
          suggestions={suggestions}
        />
      ) : null}

      <div className={styles.rows}>
        {getApplicantCreditCheckRows({ creditCheck, t }).map(row => (
          <RentalPortalKeyFactsWidgetItem
            key={row.key}
            label={row.label}
            value={row.value}
          />
        ))}
        {creditCheck.expected ? (
          <ApplicantCreditCheckResult
            canViewSensitive={canViewSensitive}
            result={creditCheck.expected}
          />
        ) : null}
      </div>

      {dismissedTexts.length > 0 ? (
        <div className={styles.lines}>
          {dismissedTexts.map(item => (
            <Text isSecondary className={styles.line} key={item.id}>
              {item.text}
            </Text>
          ))}
        </div>
      ) : null}

      {getIsApplicantCreditCheckAwaiting(creditCheck) ? (
        <Text isSecondary className={styles.line}>
          {t('RentalPortal.ApplicantCreditCheckAwaitingKey')}
        </Text>
      ) : null}

      {supplementary.length > 0 ? (
        <ApplicantCreditCheckSupplementary
          canViewSensitive={canViewSensitive}
          results={supplementary}
        />
      ) : null}

      {getIsApplicantCreditCheckInconclusive(creditCheck.expected) ? (
        <Text isSecondary className={styles.line}>
          {t('RentalPortal.ApplicantCreditCheckAlternativeEvidenceKey')}
        </Text>
      ) : null}

      <ApplicantCreditCheckActions
        applicantData={applicantData}
        isPreview={isPreview}
      />
    </>
  )
}

export default ApplicantCreditCheckContent
